import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal } from "react-icons/tb";
import { CurrencyIcon } from "../../../Components/Atoms/CurrencyIcon";
import { ModernFilterBar } from "../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_STABLES_HISTORY_FILTERS,
  STABLES_HISTORY_CURRENCIES,
  buildStablesHistoryFilterTags,
  exportStablesHistoryCsv,
  getStablesHistoryPaymentMethods,
  getStablesHistoryStatuses,
  hasActiveStablesHistoryFilters,
  isChipFilterActive,
  removeStablesHistoryFilterTag,
} from "./stablesHistoryFilters";

const StableFilterIcon = ({ asset }) => <CurrencyIcon asset={asset} size={18} />;

const getStableOptionIcon = (option) => {
  const Icon = () => <StableFilterIcon asset={option.id} />;
  return Icon;
};

const StableFilterButtonIcon = ({ className }) => (
  <CurrencyIcon asset="usdc" size={16} className={className} />
);

const StablesMoreFiltersForm = ({ draft, onChange }) => {
  const statuses = getStablesHistoryStatuses();
  const paymentMethods = getStablesHistoryPaymentMethods();

  return (
    <div className="extract-more-filters-form">
      <MoreFiltersDateSection draft={draft} onChange={onChange} />
      <MoreFiltersAmountSection draft={draft} onChange={onChange} idPrefix="stables-more" />
      <MoreFiltersCheckboxSection
        label={intl.get("stables.filterStable")}
        options={STABLES_HISTORY_CURRENCIES}
        selectedValues={draft.currencies}
        onChange={(currencies) => onChange({ ...draft, currencies })}
        idPrefix="stables-more-currency"
        getOptionIcon={getStableOptionIcon}
      />
      <MoreFiltersCheckboxSection
        label={intl.get("stables.filterStatus")}
        options={statuses}
        selectedValues={draft.statuses}
        onChange={(statuses) => onChange({ ...draft, statuses })}
        idPrefix="stables-more-status"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("stables.filterPaymentMethod")}
        options={paymentMethods}
        selectedValues={draft.paymentMethods}
        onChange={(paymentMethods) => onChange({ ...draft, paymentMethods })}
        idPrefix="stables-more-payment"
      />
    </div>
  );
};

export const StablesHistoryFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  historyType = "all",
}) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isChipFilterActive(filters, "amount"),
    },
    {
      id: "currency",
      icon: StableFilterButtonIcon,
      label: intl.get("stables.filterStable"),
      active: isChipFilterActive(filters, "currency"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="stables-filter" />;
      case "currency":
        return (
          <CheckboxListFilterPanel
            options={STABLES_HISTORY_CURRENCIES}
            selectedValues={draft.currencies}
            onChange={(currencies) => onChange({ ...draft, currencies })}
            idPrefix="stables-currency"
            getOptionIcon={getStableOptionIcon}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_STABLES_HISTORY_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isChipFilterActive(filters, "more")}
      buildFilterTags={buildStablesHistoryFilterTags}
      hasActiveFilters={hasActiveStablesHistoryFilters}
      removeFilterTag={removeStablesHistoryFilterTag}
      onExportClick={() => exportStablesHistoryCsv(filteredItems, { type: historyType, filters })}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <StablesMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        currency: intl.get("stables.filterStable"),
      }}
    />
  );
};
